const variables = {
  API_URL: process.env.VUE_APP_AXIOS_BASE_URL,
  SSO_URL: process.env.VUE_APP_SSO_URL,
  SIGNALR_URL: process.env.VUE_APP_SIGNALR_URL,
  HOME_URL: process.env.VUE_APP_HOME_URL,
  LOCAL_URL: process.env.VUE_APP_LOCAL_URL,
  HEADERTITLE: process.env.VUE_APP_HEADERTITLE,
  BOTURL: process.env.VUE_APP_BOTURL,
  };
  
  export default variables;
  